import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'

export default (props) => {
  const { item, onClickItem } = props

  const { formatMessage } = useIntl()

  const subTitle = formatMessage(
    { id: 'groups.subscribers.subtitle' },
    { subscriberCount: item.subtitle || 0 },
  )

  const primaryContent = (
    <Typography variant="subtitle2">{item.title}</Typography>
  )
  return (
    <ListItem role={undefined} dense button onClick={() => onClickItem(item)}>
      <ListItemText primary={primaryContent} secondary={subTitle} />
    </ListItem>
  )
}
